<template>
    <div
        v-if="feedback"
        class="feedback"
        :class="feedback.type"
    >
        {{ feedback.message }}
    </div>
</template>

<script setup lang="ts">
    import type { FeedbackMessage } from '../../types/quiz';

    defineProps<{
        feedback: FeedbackMessage | null;
    }>();
</script>

<style scoped>
    .feedback {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        padding: 20px 40px;
        border-radius: 16px;
        font-size: 16px;
        font-weight: 700;
        text-align: center;
        z-index: 200;
        min-width: 300px;
        animation: fadeIn 0.3s ease-out;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: translate(-50%, -50%) scale(0.8);
        }

        to {
            opacity: 1;
            transform: translate(-50%, -50%) scale(1);
        }
    }

    .feedback.correct {
        background: #4ade80;
        color: white;
    }

    .feedback.wrong {
        background: #f87171;
        color: white;
    }
</style>
